import classes from './ItemV2.module.css'

export default function ItemSimpleV2 ({children}) {
    return <div className={`${classes.item}`}>
        <div>
            {children}
        </div>
    </div>
}
